import axios from "axios";

const GETDATAMESRDV_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/rdv/user";
const GETRDVPRINT_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/rdv/print";
const DELETEMESRDV_API_BASE_URL = "https://doclicapp.herokuapp.com/api/rdv";
//
const GETANALYSERDV_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/rdv/analyse";
class ServiceMesRdv {
  getdatamesrdv(id) {
    return axios.get(GETDATAMESRDV_API_BASE_URL + "/" + id);
  }
  deletemesrdv(id) {
    return axios.delete(DELETEMESRDV_API_BASE_URL + "/" + id);
  }
  getRdvById(idRdv) {
    return axios.post(GETRDVPRINT_API_BASE_URL, { id: idRdv });
  }
  getAnalysesByRdv(id) {
    return axios.get(GETANALYSERDV_API_BASE_URL + "/" + id);
  }
}

export default new ServiceMesRdv();
